<template>
  <div>
    <layout-sub-modulo>
      <template v-slot:title>Parametrización de Empresas</template>
      <template v-slot:body>
        <table-empresas
          :listadoEmpresas="listadoEmpresas"
          @cambiar-estado-empresa="cambiarEstadoEmpresa"
          @mostrar-empleados="mostrarEmpleados"
          @eliminar-empresa="eliminarEmpresa"
        >
          <v-btn
            class="px-2 mr-1 text-white text-capitalize"
            color="botonRefrescar"
            dark
            :loading="listadoEmpresas.loading"
            @click="listarEmpresas"
          >
            <v-icon>refresh</v-icon>
            Refrescar
          </v-btn>

          <v-btn
            class="px-2 mr-1 text-white text-capitalize"
            color="primary"
            dark
            @click="$router.push({ name: 'registrarempresa' })"
          >
            <v-icon>add</v-icon>
            Registrar Empresa
          </v-btn>
        </table-empresas>
      </template>
    </layout-sub-modulo>
  </div>
</template>

<script>
import LayoutSubModulo from '../../../components/Layout/SubModulo.vue';
import empresaService from '../../../Services/empresaService';
import TableEmpresas from './Table/EmpresasTable.vue';
import { alertWarningConfirmar } from '../../../plugins/sweetalert2';

export default {
  name: 'Empresas',

  components: {
    LayoutSubModulo,
    TableEmpresas,
  },

  data() {
    return {
      listadoEmpresas: {
        data: [],
        loading: false,
      },
    };
  },

  async mounted() {
    await this.listarEmpresas();
  },

  methods: {
    async listarEmpresas() {
      this.listadoEmpresas.loading = true;
      this.listadoEmpresas.data = [];
      const empresas = await empresaService.buscarTodos();
      this.listadoEmpresas.data = empresas.data;
      this.listadoEmpresas.loading = false;
    },

    async cambiarEstadoEmpresa(empresa) {
      const inactivaEmpresa = await alertWarningConfirmar(
        `¿Está seguro de ${
          empresa.esta_activo ? 'inactivar' : 'activar'
        } la empresa ${empresa.razon_social}?`
      );
      if (!inactivaEmpresa.isConfirmed) {
        return;
      }
      const empresaActualizada = {
        esta_activo: !empresa.esta_activo,
      };
      await empresaService.actualizarPorNit(empresa.nit, empresaActualizada);
      this.listarEmpresas();
    },

    async mostrarEmpleados(empresa) {
      const muestraEmpleados = await alertWarningConfirmar(
        `¿Está seguro de ${
          empresa.muestra_empleados ? 'ocultar' : 'mostrar'
        } la información desactualizada de los empleados de la empresa ${
          empresa.razon_social
        }?`
      );
      if (!muestraEmpleados.isConfirmed) {
        return;
      }

      const empresaActualizada = {
        muestra_empleados: !empresa.muestra_empleados,
      };
      await empresaService.actualizarPorNit(empresa.nit, empresaActualizada);
      this.listarEmpresas();
    },

    async eliminarEmpresa(empresa) {
      const { nit, razon_social } = empresa;
      const eliminaEmpresa = await alertWarningConfirmar(
        `¿Está seguro de eliminar la empresa ${razon_social}?`
      );
      if (eliminaEmpresa.isConfirmed) {
        await empresaService.eliminarPorNit(nit);
        this.listarEmpresas();
      }
    },
  },
};
</script>

<style scoped></style>
